module.exports = __webpack_public_path__ + "static/media/Foot-in-the-Door Technique - gabriel-kidegho-8OMtWmTNSZo-unsplash.4acee287.jpg";